import React, { PureComponent, Fragment } from 'react';
import { withFormik } from 'formik/dist/index';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import Radio from 'common/components/styleguide/form/Radio';
import Checkbox from 'common/components/styleguide/form/Checkbox';
import RangeSlider from 'common/components/styleguide/form/RangeSlider';
import Icon from 'common/components/styleguide/Icon';

import {
  FILTERS_LABEL_KEY,
  FILTERS_NAME_KEY,
  FITLER_VALUE_KEY
} from 'common/constants/SiteConstants';

import formikWithAutoSubmit from 'common/hoc/formikWithAutoSubmit';
import { capfl, normalizeString, setFormikMultipleValues, canUseDOM } from 'common/utils';

import SS from 'common/components/category/filters/_style';
import List from "common/components/styleguide/List";

const S = {};
S.Color = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

class FilterParameter extends PureComponent {
  componentDidMount() {
    const { addFilterResolve } = this.props;
    if (addFilterResolve) {
      addFilterResolve();
    }
  }
  onFilterChange = e => {
    const {
      values,
      filterName,
      setFormikMultipleValues,
      setFieldValue,
      setFieldTouched
    } = this.props;
    setFormikMultipleValues(e.target, values, setFieldValue);
    setFieldTouched(filterName);
  };
  onFilterBlur = () => {
    const { filterName, setFieldTouched } = this.props;
    setFieldTouched(filterName);
  };
  renderInput = () => {
    const {
      filterValueId,
      filterValueLabel,
      filterName,
      filterValue,
      filterValueSelected,
      filterType,
      setFieldValue
    } = this.props;

    if (filterType === 'radio') {
      return (
        <Radio
          id={filterValueId}
          label={<SS.LabelText>{filterValueLabel}</SS.LabelText>}
          name={filterName}
          options={[{ label: filterValueLabel, value: filterValue }]}
          setValueChecked={{
            value: filterValue,
            isChecked: filterValueSelected
          }}
          onChange={() => {
            setFieldValue(filterName, filterValue);
          }}
        />
      );
    } else {
      return (
        <Checkbox
          id={filterValueId}
          label={<SS.LabelText>{filterValueLabel}</SS.LabelText>}
          name={filterName}
          value={filterValue}
          setValueChecked={filterValueSelected}
          onChange={this.onFilterChange}
          onBlur={this.onFilterBlur}
        />
      );
    }
  };
  render() {
    const { productCount } = this.props;
    return (
      <SS.ListItem>
        {this.renderInput()}
        <SS.ProductCount>{productCount}</SS.ProductCount>
      </SS.ListItem>
    );
  }
}

class RangeSliderParameter extends PureComponent {
  componentDidMount() {
    const { addFilterResolve } = this.props;
    if (addFilterResolve) {
      addFilterResolve();
    }
  }
  render() {
    const { addFilterResolve, ...sliderParams } = this.props;
    return <RangeSlider {...sliderParams} />;
  }
}

const ColorLabel = ({ label }) => {
  if (!canUseDOM()) {
    return label;
  }
  const color = _.get(window.colorsToHEX, _.toLower(label), '');
  return (
    <Fragment>
      {color ? <S.Color color={color} /> : ''}
      {label}
    </Fragment>
  )
}

class FilterParametersList extends PureComponent {
  state = { showAll: false, isHidden: true, sliderValues: [] };
  toggleShowAll = e => {
    e.preventDefault();
    const { showAll } = this.state;
    this.setState({ showAll: !showAll });
  };
  toggleIsHidden = e => {
    e.preventDefault();
    const { isHidden } = this.state;
    this.setState({ isHidden: !isHidden });
  };
  renderParamByType = () => {
    const {
      t,
      data,
      values,
      setFieldValue,
      setFieldTouched,
      addFilterResolve
    } = this.props;
    const { showAll } = this.state;
    const filterId = data.id;
    const filterLabel = data[FILTERS_LABEL_KEY];
    const filterName = sprintf('%1$s-%2$s', data[FILTERS_NAME_KEY], filterId);
    const filterType = data.type;
    const showText = showAll ? capfl(t('show less')) : capfl(t('show more'));
    let { sliderValues } = this.state;
    let items = [];
    if (showAll) {
      items = data.values;
    } else {
      items = _.slice(data.values, 0, 5);
    }
    if (_.isEmpty(sliderValues) && values[filterName]) {
      sliderValues = _.map(values[filterName], value => {
        return _.toNumber(value);
      });
    }
    if (data.type === 'slider') {
      return (
        <RangeSliderParameter
          values={data.values}
          sliderValues={sliderValues}
          step={null}
          onChange={sliderValues => {
            this.setState({ sliderValues });
          }}
          onAfterChange={sliderValues => {
            setFieldValue(filterName, sliderValues);
            this.setState({ sliderValues: [] });
          }}
          addFilterResolve={addFilterResolve(filterName, filterLabel)}
        />
      );
    } else if (data.type === 'color') {
      return (
        <div>
          <List reset>
            {_.map(items, (item, index) => {
              const filterValue = item[FITLER_VALUE_KEY];
              const filterValueLabel = <ColorLabel label={item[FILTERS_LABEL_KEY]} />
              const filterValueSelected = item.selected;
              const filterValueId = sprintf(
                '%1$s-%2$s',
                filterName,
                normalizeString(filterValue, '-', false)
              );
              return (
                <FilterParameter
                  key={filterValueId + '-' + index}
                  values={values}
                  filterId={filterId}
                  filterName={filterName}
                  filterValueId={filterValueId}
                  filterValue={filterValue}
                  filterValueLabel={filterValueLabel}
                  filterValueSelected={filterValueSelected}
                  filterType={filterType}
                  setFieldValue={setFieldValue}
                  setFormikMultipleValues={setFormikMultipleValues}
                  setFieldTouched={setFieldTouched}
                  productCount={item.productCount}
                  addFilterResolve={addFilterResolve(filterName, filterLabel)}
                />
              );
            })}
          </List>
          <div>
            {data.values && data.values.length > 5 ? (
              <SS.ShowMore href="#" onClick={this.toggleShowAll}>
                {showText}
              </SS.ShowMore>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <List reset>
            {_.map(items, (item, index) => {
              const filterValue = item[FITLER_VALUE_KEY];
              const filterValueLabel = item[FILTERS_LABEL_KEY];
              const filterValueSelected = item.selected;
              // const filterValueId = sprintf('%1$s-%2$s', filterName, hashCode(filterValue));
              const filterValueId = sprintf(
                '%1$s-%2$s-%3$s',
                filterName,
                normalizeString(filterValue, '-', false),
                index
              );
              return (
                <FilterParameter
                  key={filterValueId + '-' + index}
                  values={values}
                  filterId={filterId}
                  filterName={filterName}
                  filterValueId={filterValueId}
                  filterValue={filterValue}
                  filterValueLabel={filterValueLabel}
                  filterValueSelected={filterValueSelected}
                  filterType={filterType}
                  setFieldValue={setFieldValue}
                  setFormikMultipleValues={setFormikMultipleValues}
                  setFieldTouched={setFieldTouched}
                  productCount={item.productCount}
                  addFilterResolve={addFilterResolve(filterName, filterLabel)}
                />
              );
            })}
          </List>
          <div>
            {data.values && data.values.length > 5 ? (
              <SS.ShowMore href="#" onClick={this.toggleShowAll}>
                {showText}
              </SS.ShowMore>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    }
  };
  render() {
    const { data, isLast = false, hideParamsWithSingleValue } = this.props;
    const { isHidden } = this.state;
    const filterLabel = data[FILTERS_LABEL_KEY].replace(/\u00a0/g, " "); // replace &nbsp;
    const values = _.get(data, 'values', []);
    if ((hideParamsWithSingleValue && values.length > 1) || !hideParamsWithSingleValue) {
      return (
        <SS.FilterSection isLast={isLast}>
          <SS.FilterTitle onClick={this.toggleIsHidden}>
            {filterLabel}
            <SS.TitleIcon>
              {isHidden ? (
                <Icon className="nc-ic_keyboard_arrow_down_48px" />
              ) : (
                <Icon className="nc-ic_keyboard_arrow_up_48px" />
              )}
            </SS.TitleIcon>
          </SS.FilterTitle>
          <SS.FormWrapper isHidden={isHidden}>
            {this.renderParamByType()}
          </SS.FormWrapper>
        </SS.FilterSection>
      );
    }
    return null;
  }
}

const FilterParametersGroup = ({
  t,
  data,
  values,
  hideParamsWithSingleValue,
  setFieldValue,
  setFieldTouched,
  addFilterResolve
}) => {
  return _.map(data, (item, i) => {
    const isLast = i === data.length - 1;
    return (
      <FilterParametersList
        t={t}
        key={'params-filters-' + item.id + '-' + i}
        data={item}
        values={values}
        hideParamsWithSingleValue={hideParamsWithSingleValue}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        addFilterResolve={addFilterResolve}
        isLast={isLast}
      />
    );
  });
};

const FilterParametersForm = ({
  t,
  data,
  values,
  hideParamsWithSingleValue,
  setFieldValue,
  setFieldTouched,
  handleSubmit,
  addFilterResolve
}) => {
  if (!_.isEmpty(data)) {
    const groups = _.groupBy(data, item => {
      return item.group ? item.group : '';
    });
    return (
      <form onSubmit={handleSubmit}>
        {_.map(groups, (group, key) => {
          const groupKey = key ? normalizeString(key, '-') : 'nogroup';
          return (
            <FilterParametersGroup
              key={'params-filters-group-' + groupKey + key}
              t={t}
              data={group}
              values={values}
              hideParamsWithSingleValue={hideParamsWithSingleValue}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              addFilterResolve={addFilterResolve}
            />
          );
        })}
      </form>
    );
  }
  return null;
};

const formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => {
    const { activeFilters } = props;
    let propsToReturn = {};
    if (!_.isEmpty(activeFilters) && !_.isEmpty(activeFilters.param)) {
      propsToReturn = _.cloneDeep(activeFilters.param);
    }
    return propsToReturn;
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    const { submitFilters } = props;
    if (submitFilters) {
      const paramValues = _.pickBy(values);
      if (!_.isEmpty(paramValues)) {
        submitFilters({ param: paramValues });
      } else {
        submitFilters({ param: null });
      }
    }
    setSubmitting(false);
  }
});

const EnhancedFilterParametersForm = formikEnhancer(
  formikWithAutoSubmit(FilterParametersForm)
);

export default withTranslation()(EnhancedFilterParametersForm);
